export default "__VITE_ASSET__CrQmaq0X__"